import { IRootState } from '../../../store'
import { ISignerData } from '../store/completeChart.types'

export const getSignerListSelector = (state: IRootState): ISignerData => state.signerData.signerList
